import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  Typography,
  styled,
} from "@material-ui/core";
import { useParams } from "react-router-dom";

import { TicketInfo } from "../../api/services";
import { APIError } from "../../components/APIError";
import { CustomPaginatedTableContainer } from "../../components/CustomTableComponents";
import { useAccountTickets } from "../FinancialSummary/hooks/useAccountTickets";
import { ColumnHead } from "../../components/CustomTableComponents/ColumnHead";
import { LoadingRow } from "../../components/CustomTableComponents/LoadingRow";
import { TicketRow } from "./components/TicketRow";
import { PageHeader } from "../../components/PageHeader";

const TicketPageHeader = styled(PageHeader)(({ theme }) => ({
  minWidth: theme.spacing(25),
  marginBottom: theme.spacing(1),
}));

export const TicketsView: React.FC = () => {
  const [ticketStatus] = useState("Open,Error");
  const { accountNumber } = useParams();
  const { data: tickets, status, error } = useAccountTickets(
    accountNumber,
    ticketStatus,
  );
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="row" flexWrap="wrap" mb={2}>
        <TicketPageHeader title="Status">
          <Typography variant="h5" color="textPrimary">
            Open, Error
          </Typography>
        </TicketPageHeader>
        <TicketPageHeader title="Created">
          <Typography variant="h5" color="textPrimary">
            Last 12 months
          </Typography>
        </TicketPageHeader>
      </Box>
      <Box>
        {error ? (
          <APIError title="We could not load tickets for this account." />
        ) : (
          <CustomPaginatedTableContainer maxWidth="1400px" width="100%">
            <Table>
              <TableHead data-testid="Tickets__TableHead">
                <TableRow>
                  <ColumnHead boxProps={{ width: "128px" }}>Created</ColumnHead>
                  <ColumnHead boxProps={{ width: "96px" }}>Status</ColumnHead>
                  <ColumnHead>Summary</ColumnHead>
                  <ColumnHead boxProps={{ width: "200px" }}>Step</ColumnHead>
                  <ColumnHead boxProps={{ width: "128px" }}>
                    Team, User
                  </ColumnHead>
                  <ColumnHead boxProps={{ width: "128px" }}>
                    Priority
                  </ColumnHead>
                  <ColumnHead boxProps={{ width: "96px" }}>Due</ColumnHead>
                </TableRow>
              </TableHead>
              <TableBody>
                {status === "loading" ? (
                  <LoadingRow col={7} />
                ) : tickets && tickets.length > 0 ? (
                  tickets!.map((ticket: TicketInfo) => (
                    <TicketRow ticket={ticket} key={ticket.id} />
                  ))
                ) : (
                  tickets && (
                    <TableRow>
                      <TableCell colSpan={7} data-testid="TicketView__Empty">
                        No tickets for this account.
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </CustomPaginatedTableContainer>
        )}
      </Box>
    </Box>
  );
};
